module.exports = __webpack_public_path__ + "exo-latin-400italic.11510e4de28d62aa3aa5.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-400italic.svg
// module id = ../../../../typeface-exo/files/exo-latin-400italic.svg
// module chunks = styles